/* 商品ページ：画像の外を横スワイプ → 前後の商品へ。位置表示「‹ RING 03 / 24 ›」と ← → キーも（Y/da jewelry） */
(function () {
  var data = document.getElementById('YdaSwipeNavData');
  if (!data) return;
  var urls;
  try { urls = JSON.parse(data.textContent); } catch (e) { return; }
  if (!urls || (!urls.prev && !urls.next)) return;

  var EDGE = 24;     // 画面の端から24pxは無視（Safariの「戻る」を優先）
  var MIN_DIST = 60; // 横に60px以上動いたときだけ反応
  var RATIO = 1.5;   // 横の動きが縦の1.5倍以上のときだけ（縦スクロールの誤反応防止）
  var IGNORE = [
    'media-gallery', 'slider-component', 'product-modal', 'modal-dialog',
    '.product__media-wrapper', '.ysc', 'input', 'select', 'textarea', '[data-swipe-ignore]'
  ].join(',');

  var startX = 0, startY = 0, tracking = false;

  function scrollsSideways(el) {
    while (el && el !== document.body) {
      var ox = getComputedStyle(el).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth) return true;
      el = el.parentElement;
    }
    return false;
  }
  function overlayOpen() { // メニュー・カート・モーダルが開いているとき
    return Array.prototype.some.call(document.body.classList, function (c) {
      return c.indexOf('overflow-hidden') === 0;
    });
  }

  document.addEventListener('touchstart', function (e) {
    tracking = false;
    if (e.touches.length !== 1) return;
    var t = e.touches[0];
    if (t.clientX < EDGE || t.clientX > window.innerWidth - EDGE) return;
    if (e.target.closest && e.target.closest(IGNORE)) return;
    if (scrollsSideways(e.target) || overlayOpen()) return;
    startX = t.clientX; startY = t.clientY; tracking = true;
  }, { passive: true });

  document.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!tracking) return;
    tracking = false;
    var t = e.changedTouches[0];
    var dx = t.clientX - startX, dy = t.clientY - startY;
    if (Math.abs(dx) < MIN_DIST || Math.abs(dx) < Math.abs(dy) * RATIO) return;
    if (window.getSelection && String(window.getSelection()).length) return;
    go(dx < 0 ? 'next' : 'prev');
  }, { passive: true });

  function mark(dir) {
    try { sessionStorage.setItem('yda-swipe-dir', dir + '|' + Date.now()); } catch (err) {}
  }
  function go(dir) {
    if (!urls[dir]) return;
    mark(dir);
    window.location.href = urls[dir];
  }

  // タイトルの行（HOMEの左）に「‹ RING 03 / 24 ›」を置く
  function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }
  (function buildCounter() {
    if (!urls.index || !urls.total) return;
    var row = document.querySelector('.ptt__row');
    if (!row || row.querySelector('.yda-pnav')) return;
    var w = Math.max(2, String(urls.total).length);
    var box = document.createElement('nav');
    box.className = 'yda-pnav';
    box.setAttribute('aria-label', 'Product navigation');
    [['prev', '‹', 'Previous product'], ['label'], ['next', '›', 'Next product']].forEach(function (it) {
      if (it[0] === 'label') {
        var s = document.createElement('span');
        s.className = 'yda-pnav__label';
        s.textContent = (urls.label ? urls.label + ' ' : '') + pad(urls.index, w) + ' / ' + pad(urls.total, w);
        box.appendChild(s);
        return;
      }
      if (!urls[it[0]]) return;
      var a = document.createElement('a');
      a.className = 'yda-pnav__arrow';
      a.href = urls[it[0]];
      a.textContent = it[1];
      a.setAttribute('aria-label', it[2]);
      a.addEventListener('click', function () { mark(it[0]); });
      box.appendChild(a);
    });
    row.insertBefore(box, row.querySelector('.ptt__home'));
  })();

  // PC：← → キーでも移動（文字の入力中やメニュー・画像の全画面表示中は反応しない）
  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName))) return;
    if (t && t.closest && t.closest('media-gallery, slider-component, .ysc')) return;
    if (overlayOpen()) return;
    go(e.key === 'ArrowRight' ? 'next' : 'prev');
  });

  // 次の商品ページを先読み（Chrome系で切替が速くなる）
  if (urls.next) {
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.href = urls.next;
    document.head.appendChild(l);
  }
})();
